import { render, staticRenderFns } from "./deliveryPlan.vue?vue&type=template&id=37c39f9f"
import script from "./deliveryPlan.vue?vue&type=script&lang=js"
export * from "./deliveryPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports